import Error404 from './404.vue';

export default {
	Error404
}
